import React from "react";
import styled from "styled-components";
import UserSVG from "@src/assets/img/user-avatar.svg";
import { theme } from "@src/theme";
const DropdownItem = styled.li`
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${({ theme }): string => theme.colors.gray};
  &:hover {
    color: ${({ theme }): string => theme.colors.yellow};
    background-color: ${({ theme }): string => theme.colors.opacity_yellow};
  }
  &:focus: {
    border: 1px solid ${({ theme }): string => theme.colors.yellow};
  }
  user-select: none;
`;
const CuratorDropdownOption = ({
  name,
  imageUrl,
}: {
  name: string;
  imageUrl: string;
}) => {
  return (
    <DropdownItem>
      <img
        src={imageUrl || UserSVG}
        alt="Curator"
        style={{
          objectFit: imageUrl ? "cover" : "contain",
          width: "30px",
          height: "30px",
          marginRight: "10px",
          border: `1px solid ${theme.colors.yellow}`,
        }}
      />
      {name}
    </DropdownItem>
  );
};

export default CuratorDropdownOption;
